@if (showSpinner) {
<app-spinner></app-spinner>
}

<div class="inner-page-header">
  <h3>الشروط و الأحكام</h3>
</div>
<div class="request-control" #goUp>
  <div class="right-side">
    <quick-search [placeholder]="' البحث عن الشروط والأحكام ...'" (searchResults)="quickSearch($event)"></quick-search>
  </div>

  <div class="new-element">
    <button class="btn btn-add" [routerLink]="['/pages/services/terms-conditions', 'new']">
      <img src="assets/images/svg/add-icon.svg" alt="" />
      إضافة شروط وأحكام
    </button>
  </div>
</div>

<div class="custom-card">
  @if (termsConditionsList) {
  <div class="row custom-container">
    @for (tc of termsConditionsList | paginate: config; track tc.id; let i = $index) {
    <div class="col-6 item">
      <div>
        {{ tc.label }}
      </div>
      <div class="setting-container">
        <div class="setting-item wrench" [routerLink]="['/pages/services/terms-conditions', tc.id]">
          <img src="assets/images/svg/wrench.svg" alt="" />
        </div>
        <div class="setting-item delete" (click)="showDeleteConfirmationBox(tc.id, tc.label, i)"></div>
      </div>
    </div>
    }
  </div>
  } @else {
  <div class="empty-services">لا يوجد شروط واحكام</div>
  }
</div>
@if (termsConditionsList && termsConditionsList.length > config.itemsPerPage) {
<ayen-pagination (pageData)="pageChanged($event)" (pageSize)="pageSizeChanged($event)" [id]="'termsConditionsList'"
  [totalCount]="config.totalItems" [itemsPerPage]="config.itemsPerPage" (pageChange)="changeToSpecific($event)"
  [currentPage]="config.currentPage">
</ayen-pagination>
}
